import { StreamOperation } from '../../../types/index.js';
import { IndexerGrpcArchiverTransformer } from './IndexerGrpcArchiverTransformer.js';
/**
 * @category Indexer Stream Transformer
 */
export class IndexerArchiverStreamTransformer {
    static spotAverageEntriesStreamCallback = (response) => {
        const averageEntry = response.averageEntry;
        return {
            averageEntry: averageEntry
                ? IndexerGrpcArchiverTransformer.grpcSpotAverageEntryToSpotAverageEntry(averageEntry)
                : undefined,
            operation: StreamOperation.Update,
            timestamp: response.timestamp,
        };
    };
}
